import { switcher } from 'reducers/utils';
import { ACTIONS } from '../const';

const { SET_CONTENT, CLEAR_CONTENT } = ACTIONS;

function getDefaultContent() {
    return {
        description: '',
        embed: '',
        fromSection: 0,
        fromTerm: 0,
        includeLinks: false,
        includeTags: false,
        selectedSections: [],
        title: '',
        tos: false,
        url: '',
    };
}

export default switcher(getDefaultContent(), {
    [SET_CONTENT](state, { payload }) {
        return { ...state, ...payload };
    },
    [CLEAR_CONTENT]() {
        return getDefaultContent();
    },
});



// WEBPACK FOOTER //
// ./src/reducers/manage_content.js